import config from './../config';

const  constants = {
    primaryColor: config.colors.primaryColor,
    primary2Color: config.colors.primary2Color,
    complementaryColor: config.colors.complementaryColor
    
  };

export default constants;



// WEBPACK FOOTER //
// ./src/parameters/constants.js